import { Button, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';

interface EditActionsProps {
    onCancel: () => void;
    onSave: () => void;
    saveDisabled?: boolean;
    cancelDisabled?: boolean;
    /** Save button color — `secondary` (CTA accent) for the form cards, `primary` for inline edits. */
    saveColor?: 'primary' | 'secondary';
    cancelVariant?: 'text' | 'outlined';
    size?: 'small' | 'medium';
    saveStartIcon?: ReactNode;
    saveEndIcon?: ReactNode;
}

/**
 * Cancelar / Guardar button pair shared by the editable registry cards. Right-aligned,
 * auto-width on desktop; on mobile the two buttons split the full width evenly, matching
 * the Figma mock.
 */
export const EditActions = ({
    onCancel,
    onSave,
    saveDisabled = false,
    cancelDisabled = false,
    saveColor = 'primary',
    cancelVariant = 'outlined',
    size,
    saveStartIcon,
    saveEndIcon,
}: EditActionsProps) => {
    const isMobile = useIsMobile();

    return (
        <Stack direction='row' spacing={1} justifyContent='flex-end' sx={isMobile ? { width: '100%' } : undefined}>
            <Button
                variant={cancelVariant}
                color='primary'
                onClick={onCancel}
                disabled={cancelDisabled}
                size={size}
                sx={isMobile ? { flex: 1 } : undefined}
            >
                {_('Cancelar')}
            </Button>
            <Button
                variant='contained'
                color={saveColor}
                onClick={onSave}
                disabled={saveDisabled}
                size={size}
                startIcon={saveStartIcon}
                endIcon={saveEndIcon}
                sx={isMobile ? { flex: 1 } : undefined}
            >
                {_('Guardar')}
            </Button>
        </Stack>
    );
};
